<div class="d-flex flex-column flex-lg-row" [class.flex-lg-row-reverse]="reverse">
  <div class="col-lg-9">
    <x-ghost-media></x-ghost-media>
  </div>
  <div class="col-lg-3 mt-4 mt-lg-0 px-4 d-flex flex-column justify-content-center">
    <x-ghost-title class="mb-2"></x-ghost-title>
    <x-ghost-paragraph class="mb-2"></x-ghost-paragraph>
    <x-ghost-paragraph class="mb-2"></x-ghost-paragraph>
    <x-ghost-button></x-ghost-button>
  </div>
</div>
